import { getPaymentExpiresAt } from "../lib/paymentHold"
import { useTimer } from "./useTimer"

export function usePaymentHoldTimer(createdAt?: string | null, expiredAt?: string | null) {
    const deadline = getPaymentExpiresAt(createdAt, expiredAt)
    return useTimer(deadline)
}
